// 운동목적 — 잠재회원·상담이 공유하는 다중선택 값.
// 백엔드 ExercisePurpose enum 과 값·순서를 맞춘다. 실제 옵션은 enum API 가 단일 소스이고 여기는 fallback.
export const EXERCISE_PURPOSE_LABELS = {
  DIET: '다이어트',
  POSTURE_CORRECTION: '자세 및 체형교정',
  STRENGTH: '근력증진',
  PAIN_MANAGEMENT: '통증관리',
  OTHER: '기타',
};

export const EXERCISE_PURPOSE_OPTIONS = Object.entries(EXERCISE_PURPOSE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const getExercisePurposeLabel = purpose => EXERCISE_PURPOSE_LABELS[purpose] || purpose || '-';

// 목록·상세 응답은 "DIET,STRENGTH" 형태의 콤마 문자열로 내려온다.
export const parseExercisePurposes = value => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return String(value)
    .split(',')
    .map(v => v.trim())
    .filter(Boolean);
};
